module.exports = __webpack_public_path__ + "img/amex-64px.92fd8d06.webp";